export function expectNeverAsString(value: never): string {
  return value as string;
}
